import { render, staticRenderFns } from "./PortineriaRicercaStanzeView.vue?vue&type=template&id=6ebd5290&"
import script from "./PortineriaRicercaStanzeView.vue?vue&type=script&lang=ts&"
export * from "./PortineriaRicercaStanzeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports